import { ChevronLeft, ChevronRight } from 'lucide-react';

export interface MonthNavProps {
  month: string;
  onPrev?: () => void;
  onNext?: () => void;
}

export function MonthNav({ month, onPrev, onNext }: MonthNavProps) {
  return (
    <div className='mk-monthnav'>
      <button
        type='button'
        className='mk-monthnav__btn'
        onClick={onPrev}
        aria-label='Previous month'
      >
        <ChevronLeft size={22} strokeWidth={2.5} />
      </button>
      <span className='mk-monthnav__label'>{month}</span>
      <button
        type='button'
        className='mk-monthnav__btn'
        onClick={onNext}
        aria-label='Next month'
      >
        <ChevronRight size={22} strokeWidth={2.5} />
      </button>
    </div>
  );
}
